const collageImage = `${process.env.REACT_APP_BACKEND_URL}images/colleges`
const staffImage = `${process.env.REACT_APP_BACKEND_URL}images/staff`

export {
    collageImage,
    staffImage
}